<!-- 
    A buttton styled to look like a link 
    Note: Consider consolidating under BaseButton    
-->
<template>
    <button 
        type="button"
        :disabled="disabled"
        class="text-button"
        @click="$emit('click', $event)"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props:{
        disabled: Boolean
    }
};
</script>